export interface Research {
  company_id: string;
  company_name: string;
  name: string;
  tree: string;
  tree360: string;
  id: string;
}
